/* Hitman Rips — Scroll-triggered reveal animations via Intersection Observer */
(function () {
  'use strict';

  var threshold = 0.15;
  var rootMargin = '0px 0px -60px 0px';

  function reveal(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('hr-revealed');
        observer.unobserve(entry.target);
      }
    });
  }

  var observer = new IntersectionObserver(reveal, {
    threshold: threshold,
    rootMargin: rootMargin
  });

  function init() {
    document.querySelectorAll('.hr-reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
